import * as React from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../utils/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-sm border px-2.5 py-0.5 text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-[#8BC6FD] bg-[#D8EFFE] text-[#3E8FFA] hover:bg-[#D8EFFE]/80',
        secondary: 'border-[#DDE0E5] bg-[#FAFBFF] text-[#6E7178] hover:bg-[#FAFBFF]/80',
        tertiary: 'border-[#ADC6FF] bg-[#F0F5FF] text-[#1D39C4] hover:bg-[#FAFBFF]/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
